import GravityV3Adapter from 'teacher-ui-client/adapters/gravity/v3-adapter'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import { join } from 'teacher-ui-client/utils/uri'
import config from 'teacher-ui-client/config/environment'

export class DashboardPreferencesAdapter extends GravityV3Adapter {
  @service session!: SessionService

  urlForCreateRecord(_modelName: string): string {
    const { currentTeacher } = this.session
    return join(config.gravityV3Url, 'teachers', currentTeacher.id, 'dashboard-preferences').href
  }

  urlForFindRecord(_id: string, _modelName: string): string {
    const { currentTeacher } = this.session
    return join(config.gravityV3Url, 'teachers', currentTeacher.id, 'dashboard-preferences').href
  }

  urlForUpdateRecord(_id: string, _modelName: string): string {
    const { currentTeacher } = this.session
    return join(config.gravityV3Url, 'teachers', currentTeacher.id, 'dashboard-preferences').href
  }
}

export default DashboardPreferencesAdapter
